module.exports = __webpack_public_path__ + "img/aurora-bg.40ef50e4.svg";